export default __webpack_public_path__ + "static/media/IS.bb2810ef.svg";